'use client'

import { Skeleton } from '@dafiti/closet-ui'
import { buildGreetingText } from '../../../helpers/greeting'
import { useAppLayoutContext } from '../../../providers/AppLayoutProvider'
import { useMessages } from '../../../i18n/useMessages'
import * as track from '../../../tracking/header'
import { useAuth } from '@/hooks/useAuth'

export const GreetingText = () => {
  const { options, LinkComponent } = useAppLayoutContext()
  const t = useMessages()

  const { auth, isLoading } = useAuth()

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangle"
        width="w-full"
        height="20px"
        data-testid="skeleton"
      />
    )
  }

  return (
    <LinkComponent
      href={auth?.isLoggedIn ? options.urls.customer : options.urls.login}
      className="truncate hover:underline"
      onClick={() => {
        if (auth?.isLoggedIn) {
          track.userGreetingClick({
            contentType: 'header',
            complement: 'click',
          })
        } else {
          track.authenticationClick({
            contentType: 'header',
            complement: 'login',
          })
        }
      }}
      aria-label={auth?.isLoggedIn ? t.header.account : t.header.login}
    >
      {buildGreetingText(auth, t)}
    </LinkComponent>
  )
}
